<!-- Per-item print/reprint — one row per physical item, each with the same
     Labels / Copier-sheets steppers, seeded by the parent. A row set to 0 is
     left out of the job. ONE button prints the whole set in a single job, so the
     printed "X of N" numbering stays correct. Emits (reprintAll); the parent
     submits the print. -->
<div class="reprint-section">
  <div class="reprint-section-label">{{ sectionLabel }}</div>

  <!-- A row with nothing to print is dimmed rather than hidden: it is still part
       of the delivery, and the operator needs to see that they excluded it. -->
  <div *ngFor="let it of items" class="reprint-item-row"
       [class.reprint-item-excluded]="(printsLabels ? it.labelCopies : 0) + (printsSheets ? it.sheetCopies : 0) === 0">
    <div class="reprint-item-title">{{ it.title }}</div>

    <div class="reprint-qty-controls">
      <div *ngIf="printsLabels" class="reprint-qty-line">
        <span class="reprint-qty-label">Labels</span>
        <div class="count-stepper print-stepper">
          <button class="stepper-btn" (click)="decLabel(it)" [disabled]="it.labelCopies <= 0">
            <ion-icon name="remove-outline"></ion-icon>
          </button>
          <span class="count-display">{{ it.labelCopies }}</span>
          <button class="stepper-btn" (click)="incLabel(it)">
            <ion-icon name="add-outline"></ion-icon>
          </button>
        </div>
      </div>

      <div *ngIf="printsSheets" class="reprint-qty-line">
        <span class="reprint-qty-label">Copier sheets</span>
        <div class="count-stepper print-stepper">
          <button class="stepper-btn" (click)="decSheet(it)" [disabled]="it.sheetCopies <= 0">
            <ion-icon name="remove-outline"></ion-icon>
          </button>
          <span class="count-display">{{ it.sheetCopies }}</span>
          <button class="stepper-btn" (click)="incSheet(it)">
            <ion-icon name="add-outline"></ion-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- One print button for the whole list. -->
  <button class="reprint-btn reprint-all-btn"
          [class.reprint-done]="status === 'printed'"
          [disabled]="!canPrint"
          (click)="onReprintAll()">
    <ion-icon [name]="status === 'printed' ? 'checkmark-outline' : 'print-outline'"></ion-icon>
    {{ status === 'sending' ? 'Sending…'
       : status === 'printed' ? actionVerbDone
       : actionVerb }}
  </button>
</div>
